import * as angular from "angular";
import { CampaignDataProvider } from "./data-provider/campaign.dp";
import { DataProvider } from "./data-provider/data-provider";
import { SocketService } from "./env-set-up/socket";
import { Campaign } from "./models/campaign.model";
import { Organisation } from "./models/organisation.model";
import { User } from "./models/user.model";
import { NavigationBarHelperService } from "./components/navigation/navigation-bar.helper";
import { NotificationDataProvider } from "./data-provider/notification.dp";
import { PermissionCheck } from "./shared/permission";
import { CredentialsManager } from "./shared/credentials-manager";
import { UserDataProvider } from "./data-provider/user.dp";
import { DialogUtils } from "./helper/dialog.helper";
import { SearchUtils } from "./helper/search.helper";
import { WhiteLabelDataProvider } from "./data-provider/white-label.dp";
import { ApiUserService } from "./services/user.service";

let env = {};
//Import variables if present (from env.js)
if (window) {
    angular.extend(env, window["__env"]);
}

let updateBodyClass = (): void => {
    document.body.className = "";
    document.body.classList.add(
        (window.location.hash
            .replace("#", "")
            .replace("/", "")
            .replace("_", "-") ?? "leader-home") + "-body"
    );
};
let app = angular.module("leaderApp", [
    "htmlTemplates",
    "ngRoute",
    "ngCookies",
    "ngMaterial",
    "md.data.table",
    "fixed.table.header",
    "ecanvasserDirectives",
    "ecanvasserDirectives",
    "ngResource",
    "organisation",
    "organisationSettings",
    "filters",
    "permission",
    "dndLists",
    "ngSanitize",
    "vcDataProvider",
    "credentialsManager",
    "requestInterceptor",
    "notification",
    "socket",
    "leaderBoard",
    "navigation",
    "effort",
    "campaign",
    "ecanvasserControllers",
    "vcServices",
    "vcDataProvider",
    "sharedTheme",
    "theme",
    "leaderTheme",
    "whiteLabelTheme",
]);

angular["lowercase"] = angular["$$lowercase"];
app.constant("__env", env);
app.constant("__app_type", "LEADER");
app.constant("__time_zone", Intl.DateTimeFormat().resolvedOptions().timeZone);

app.config([
    "$locationProvider",
    ($locationProvider: any) => {
        $locationProvider.hashPrefix("");
    },
]);
app.config(($httpProvider: any) => {
    angular["lowercase"] = (text?: string) => (!text ? "" : text.toLowerCase());
    $httpProvider.defaults.withCredentials = true;
    $httpProvider.interceptors.push("httpRequestInterceptor");
});
app.config(($sceDelegateProvider: any, __env: any) => {
    $sceDelegateProvider.resourceUrlWhitelist([
        // Allow same origin resource loads.
        "self",
        // Allow loading from our assets domain.  Notice the difference between * and **.
        "https://assets." + __env.host + "/**",
    ]);
});
app.config([
    "$routeProvider",
    ($routeProvider: any) => {
        $routeProvider
            .when("/", {
                reloadOnSearch: false,
                template:
                    '<vc-divisions flex class="layout-column"></vc-divisions>',
            })
            .when("/divisions", {
                reloadOnSearch: false,
                template:
                    '<vc-divisions flex class="layout-column"></vc-divisions>',
            })
            .when("/leader_users", {
                reloadOnSearch: false,
                template:
                    '<vc-organisation-users flex class="layout-column" active-organisation="$ctrl.activeOrganisation"></vc-organisation-users>',
            })
            .when("/leader_leaderboard", {
                reloadOnSearch: false,
                template:
                    '<vc-leader-board flex class="layout-column"></vc-leader-board>',
            })
            .when("/leader_people", {
                reloadOnSearch: false,
                template:
                    '<vc-house-occupants-view double-toolbar="$ctrl.doubleToolbar" flex class="layout-column"></vc-house-occupants-view>',
            })
            .when("/leader_dashboards", {
                reloadOnSearch: false,
                template:
                    '<vc-dashboards-page flex class="layout-column"></vc-dashboards-page>',
            })
            .when("/leader_voterfiles", {
                template:
                    '<vc-voter-file-list flex class="layout-column"></vc-voter-file-list>',
            })
            .when("/leader_voterfiles/conflicts", {
                template:
                    '<vc-voter-file-conflict flex class="layout-column"></vc-voter-file-conflict>',
            })
            .when("/leader_voterfiles/import/:voterFileId", {
                template:
                    '<vc-voter-file-import flex class="layout-column"></vc-voter-file-import>',
            })
            .when("/leader_voterfiles/import/:voterFileId/:imid", {
                template:
                    '<vc-voter-file-import flex class="layout-column"></vc-voter-file-import>',
            })
            .when("/leader_voterfiles/info/:erid", {
                template:
                    '<vc-voter-file-import-info flex class="layout-column"></vc-import-info>',
            })
            .when("/leader_voterfiles/info/:erid/:imid", {
                template:
                    '<vc-voter-file-import-info flex class="layout-column"></vc-import-info>',
            })
            .when("/leader_houses", {
                reloadOnSearch: false,
                template:
                    '<vc-houses-view double-toolbar="$ctrl.doubleToolbar" flex class="layout-column"></vc-houses-view>',
            })
            .when("/leader_streets", {
                reloadOnSearch: false,
                template:
                    '<vc-streets-view double-toolbar="$ctrl.doubleToolbar" flex class="layout-column"></vc-streets-view>',
            })
            .when("/leader_lists", {
                reloadOnSearch: false,
                template:
                    '<vc-groups-view double-toolbar="$ctrl.doubleToolbar" flex class="layout-column"></vc-groups-view>',
            })
            .when("/leader_map", {
                reloadOnSearch: false,
                template: '<vc-map flex class="layout-column"></vc-map>',
            })
            .when("/leader_results", {
                template:
                    '<vc-organisation-results flex class="layout-column"></vc-organisation-results>',
            })
            .when("/leader_talkingpoint", {
                template:
                    '<vc-talking-points flex class="layout-column"></vc-talking-points>',
            })
            .when("/leader_customize", {
                template:
                    '<vc-customize layout="column" flex layout-align="center center"></vc-customize>',
            })
            .when("/leader_exports", {
                reloadOnSearch: false,
                template:
                    '<vc-documents flex class="layout-column"></vc-documents>',
            })
            .when("/leader_settings", {
                template:
                    '<vc-organisation-settings flex class="layout-column"></vc-organisation-settings>',
            })
            .when("/leader_survey", {
                template:
                    '<vc-survey-list flex class="layout-column"></vc-survey-list>',
            })
            .when("/leader_survey/:surveyId", {
                template:
                    '<vc-survey-info flex class="layout-column"></vc-survey-info>',
            });
    },
]).run(
    (
        $rootScope: any,
        $location: any,
        $window: any,
        __env: any,
        NavigationBarHelperService: NavigationBarHelperService,
        SearchUtils: SearchUtils
    ) => {
        updateBodyClass();

        $rootScope.$on("$routeChangeSuccess", (event: any) => {
            $window.ga("send", "pageview", $location.path());
            NavigationBarHelperService.setSearchMode(false);
            NavigationBarHelperService.setNavigationBarHidden(false);
            NavigationBarHelperService.toggleFilterButton(false);
            SearchUtils.setSearchBar("", null, null);
            NavigationBarHelperService.setSelectedSideBarItem($location.path());
            NavigationBarHelperService.filterOffset = false;

            let mainElem = document.getElementsByClassName(
                "main-content-section"
            );
            let header = document.querySelector(".main-navbar");

            if (mainElem && mainElem[0] && header) {
                header.classList.remove("floatingNav");
            }

            NavigationBarHelperService.setShowBackButton(false);
            updateBodyClass();
        });
    }
);

export class LeaderRootController {
    private readonly $scope: any;
    private readonly $cookies: any;
    private readonly $window: any;
    private readonly dataProvider: DataProvider;
    private readonly socketService: SocketService;
    private userDataProvider: UserDataProvider;
    private readonly $location: any;
    private readonly $q: any;
    private readonly $route: any;
    private readonly $rootScope: any;
    private credentialsManager: CredentialsManager;
    public readonly permissionProvider: PermissionCheck;
    private readonly $mdMedia: any;
    public readonly navigationBarService: NavigationBarHelperService;
    private notificationDataProvider: NotificationDataProvider;
    private campaignDataProvider: CampaignDataProvider;
    private readonly dialog: DialogUtils;
    private readonly modelsUtils: any;
    private readonly __env: any;

    public isLeaderView: boolean;
    public intercomShowing = true;
    public showCampaigns = false;
    public access_token: string;
    public activeCampaign: Campaign;
    public profileMenuOpen = false;
    public showNotificationMenu = false;
    public user: User;
    public leaderSwitching = false;
    public selectedPage: string;
    public activeOrganisation: Organisation;
    public selectedOrganisation: Organisation | null;
    public smallScreen: any;
    public doubleToolbar: any;
    public whiteLabelDataProvider: WhiteLabelDataProvider;
    public subMenu = {
        leaderShowPlan: true,
        leaderShowOrganise: true,
    };
    private readonly apiUserService: ApiUserService;
    constructor(
        $scope: any,
        $cookies: any,
        $window: any,
        DataProvider: DataProvider,
        SocketService: SocketService,
        UserDataProvider: UserDataProvider,
        $location: any,
        $q: any,
        $route: any,
        $rootScope: any,
        CredentialsManager: CredentialsManager,
        PermissionCheck: PermissionCheck,
        $mdMedia: any,
        NavigationBarHelperService: NavigationBarHelperService,
        NotificationDataProvider: NotificationDataProvider,
        CampaignDataProvider: CampaignDataProvider,
        WhiteLabelDataProvider: WhiteLabelDataProvider,
        DialogUtils: DialogUtils,
        ModelsUtils: any,
        ApiUserService: ApiUserService,
        __env: any
    ) {
        this.$scope = $scope;
        this.$cookies = $cookies;
        this.$window = $window;
        this.dataProvider = DataProvider;
        this.socketService = SocketService;
        this.apiUserService = ApiUserService;
        this.userDataProvider = UserDataProvider;
        this.whiteLabelDataProvider = WhiteLabelDataProvider;
        this.$location = $location;
        this.$q = $q;
        this.$route = $route;
        this.$rootScope = $rootScope;
        this.credentialsManager = CredentialsManager;
        this.permissionProvider = PermissionCheck;
        this.$mdMedia = $mdMedia;
        this.navigationBarService = NavigationBarHelperService;
        this.notificationDataProvider = NotificationDataProvider;
        this.campaignDataProvider = CampaignDataProvider;
        this.dialog = DialogUtils;
        this.__env = __env;

        if ($location.path() == "/") {
            $location.path("/divisions");
        }
        if (this.$cookies.get("leaderShowPlan") == "false") {
            this.subMenu["leaderShowPlan"] = false;
        }
        if (this.$cookies.get("leaderShowOrganise") == "false") {
            this.subMenu["leaderShowOrganise"] = false;
        }
        NavigationBarHelperService.setSelectedSideBarItem($location.path());
        this.user = ModelsUtils.user({
            uid: this.$cookies.get("uid"),
            ufname: this.$cookies.get("ufname"),
            ulname: this.$cookies.get("ulname"),
            uemail: this.$cookies.get("uemail"),
            account_type: this.$cookies.get("account_type"),
            hash: this.$cookies.get("user_hash"),
        });

        this.notificationDataProvider.getUnseenIssuesCount();
        this.userDataProvider.setActiveUser(this.user);
        this.userDataProvider
            .getUser(this.$cookies.get("uid"))
            .then((user: User) => {
                angular.extend(this.user, user);
                this.userDataProvider.setActiveUser(this.user);
                this.notificationDataProvider.setUID(this.user.uid);

                this.initializeIntercomAndWootric();
            });
        this.activeCampaign = this.campaignDataProvider.setActiveCampaign(
            this.$cookies.getObject("campaign")
        );
        this.access_token = this.credentialsManager.getAccessToken();
        this.credentialsManager.setCredentials(
            this.activeCampaign.campaignid,
            this.access_token,
            this.activeCampaign.oid,
            true
        );

        this.$scope.$watch(
            () => this.$mdMedia("xs"),
            (small: boolean) => (this.smallScreen = small)
        );

        this.$scope.$on("$mdMenuOpen", (event: any, elem: any) => {
            if (elem.hasClass("notification-menu")) {
                this.showNotificationMenu = true;
            }
        });

        this.$rootScope.setDoubleToolbar = (doubleToolbar: boolean) => {
            this.doubleToolbar = doubleToolbar;
        };
    }

    $onInit() {
        this.campaignDataProvider
            .getOrganisations()
            .then((organisation: Organisation) => {
                this.activeOrganisation = organisation;
                this.permissionProvider.setPermission(
                    this.activeOrganisation.permissionid
                );
                this.socketService.init(organisation.oid, "organisation");
            });
        this.accessCheck();

        setInterval(() => {
            this.checkIsActive();
        }, 5 * 1000); //check if user is active every 5 seconds
    }

    setSelectedOrganisation(organisation: Organisation | null): void {
        this.selectedOrganisation = organisation;
    }

    openProfileMenu(): void {
        this.setSelectedOrganisation(null);
        this.profileMenuOpen = true;
        let removeListener = this.$scope.$on("$mdMenuClose", () => {
            this.profileMenuOpen = false;
            removeListener();
        });
    }

    initializeIntercomAndWootric(): void {
        if (
            !this.__env.test &&
            !this.user.uemail.includes("@vconnecta") &&
            !this.user.uemail.includes("@civisconnect") &&
            !this.user.uemail.includes("markaokeeffe+") &&
            !this.user.uemail.includes("@voxcitio") &&
            !this.user.uemail.includes("@ecanvasser")
        ) {
            this.initializeWootric();
            this.initializeIntercomUser();
        } else {
            this.intercomShowing = false;
        }
    }

    initializeIntercomUser(): void {
        let uid = this.__env.test
            ? "Test" + this.$cookies.get("uid")
            : this.$cookies.get("uid");
        window.intercomSettings = {
            app_id: this.__env.intercom_id,
            user_id: uid,
            user_hash: this.$cookies.get("user_hash"),
            name:
                this.$cookies.get("ufname") + " " + this.$cookies.get("ulname"),
            email: this.$cookies.get("uemail"),
            created_at: this.$cookies.get("ujoindate"),
            product_name: this.__env.product_name,
            companies: [this.companyFromCampaign(this.activeCampaign)],
        };
    }

    companyFromCampaign(campaign: Campaign): any {
        return {
            company_id: campaign.campaignid,
            name: campaign.campaignname,
            region: campaign.campaignregion,
            status: campaign.campaignstatusname,
            plan_country: campaign.cpcountry,
            interval: campaign.cpinterval,
            plan: campaign.cpname,
            monthly_spend: campaign.cpprice,
            nb_nation: campaign.nbnid,
            nb_slug: campaign.slug,
            remote_created_at: campaign.campaigntimestamp,
        };
    }

    initializeWootric(): void {
        window["wootricSettings"] = {
            email: this.user.uemail, //TODO: Required to uniquely identify a user. Email is recommended but this can be any unique identifier.
            external_id: this.user.uid, // TODO: Reference field for external integrations only. Send it along with email.
            time_delay: 1,
            product_name: this.__env.product_name,
            facebook_page: "https://www.facebook.com/" + this.__env.social,
            twitter_account: this.__env.social,
            account_token: this.__env.wootric_token, //TODO:replace it with your account token
            properties: {
                account_name: this.activeCampaign.campaignname,
                account_id: this.activeCampaign.campaignid,
                leader_id: this.activeCampaign.oid,
                permission: this.user.permissionname,
                planLevel: this.activeCampaign.cpname,
                planPrice: this.activeCampaign.cpprice,
                account_status: this.activeCampaign.campaignstatusname,
                account_created: this.activeCampaign.campaigncreationdatetime,
            },
        };
    }

    runWootric(): void {
        if (
            !this.__env.test &&
            !this.user.uemail.includes("@vconnecta") &&
            !this.user.uemail.includes("@civisconnect") &&
            !this.user.uemail.includes("markaokeeffe+") &&
            !this.user.uemail.includes("@voxcitio") &&
            !this.user.uemail.includes("@ecanvasser")
        ) {
            let url = this.$location.url();
            const pageName = url.split("?")[0].substring(1);
            this.$window.wootricSettings.properties.page = pageName ?? null;
            (window as any).wootric("run");
        }
    }

    testIntercomFab($event: any): void {
        let testIntercomDialog = this.dialog
            .alert()
            .title("Dummy intercom bubble")
            .textContent("No intercom loaded on test server")
            .targetEvent($event)
            .ok("OK");
        this.dialog.showPreConfiguredDialog(testIntercomDialog);
    }

    changeLiveCampaign(campaign: Campaign): void {
        this.campaignDataProvider.changeLiveCampaign(campaign).then(() => {
            this.userDataProvider
                .getUser(this.$cookies.get("uid"))
                .then((user: User) => {
                    angular.extend(this.user, user);
                    this.userDataProvider.setActiveUser(this.user);
                    this.notificationDataProvider.setUID(this.user.uid);
                    this.$window.location = "/";
                });
        });
    }

    navigateBack(): void {
        this.$window.history.back();
    }

    accessCheck(): void {
        this.campaignDataProvider
            .getOrganisations()
            .then((organisation: Organisation) => {
                if (
                    !organisation ||
                    !organisation.permissionid ||
                    !this.permissionProvider.hasPermission(
                        "LEADER_PAGES",
                        null,
                        organisation.permissionid
                    )
                ) {
                    this.$window.location = "/#/";
                }
            });
    }

    switchLeaderView(organisation: Organisation): void {
        this.leaderSwitching = true;
        if (organisation != this.campaignDataProvider.activeOrganisation) {
            this.campaignDataProvider
                .changeLiveCampaign(organisation.campaigns[0])
                .then(() => {
                    this.socketService.changeTopic(
                        this.activeOrganisation.oid,
                        "organisation"
                    );
                    this.dataProvider.clearAll();
                    this.access_token =
                        this.credentialsManager.getAccessToken();
                    this.credentialsManager.setCredentials(
                        this.activeCampaign.campaignid,
                        this.access_token,
                        this.activeCampaign.oid,
                        true,
                        this.$cookies.get("uid")
                    );
                    this.$window.location = "/leader.php/#/divisions";
                });
        } else {
            this.leaderSwitching = false;
            this.$window.location = "/leader.php/#/divisions";
        }
    }

    setActivePage(page: string): void {
        this.selectedPage = page;
    }

    isActivePage(page: string): boolean {
        return this.selectedPage == page;
    }
    toggleSubMenu(subMenuName: string): void {
        this.subMenu[subMenuName] = !this.subMenu[subMenuName];
        this.$cookies.put(subMenuName, `${this.subMenu[subMenuName]}`);
    }

    checkIsActive(): void {
        this.apiUserService.is_active({ type: 1 }).then(
            (response: object) => {},
            () => {
                window.location.href = "/logout.php?r=" + this.$location.url();
            }
        );
    }
}

app.controller("LeaderRootController", LeaderRootController);
